import { useQuery } from "react-query";
import { downloadSourceFile } from "../../../../actions/CarrierAgreementMgmt/Carrier";

interface DownloadLEFilesProps {
  fileName: string;
  enabledDownloadFile: boolean;
}

const useDownloadLEFiles = ({
  fileName,
  enabledDownloadFile,
}: {
  fileName: string;
  enabledDownloadFile: boolean;
}) => {
  return useQuery(["DownloadSourceFiles", fileName], downloadSourceFile, {
    refetchOnWindowFocus: false,
    enabled: enabledDownloadFile,
  });
};

export default useDownloadLEFiles;
